import React, { useContext } from 'react'
import Context from '../context'

const UnitDetails = ({ unitDetails }) => {
  const { state } = useContext(Context)

  return unitDetails && state.cart.store?.state === 'NJ'
    ? <span className="unit-details">{unitDetails}</span>
    : null
}

export default UnitDetails
